export const queryKeys = {
  profileDetail: () => ["profile", "detail"] as const,
  authenticatedUser: () => ["profile", "authenticated-user"] as const,
  featureFlags: () => ["feature-flags", "all"] as const,
  gamesFilters: () => ["games", "filters"] as const,
  gamesSearch: (filters: object) => ["games", "search", filters] as const,
  gamesRoadmap: (filters: object) => ["games", "roadmap", filters] as const,
  streamStatsProgress: (filters: object) =>
    ["stream-stats", "progress", filters] as const,
  streamStatsSummary: (filters: object) =>
    ["stream-stats", "summary", filters] as const,
  streamStatsGames: (filters: object) =>
    ["stream-stats", "games", filters] as const,
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteStreamStatsGames: (filters: object) =>
    ["stream-stats", "games", "infinite", filters] as const,
  adminUsers: (filters: object) => ["admin", "users", filters] as const,
  adminTags: (filters: object) => ["admin", "tags", filters] as const,
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteAdminTags: (filters: object) =>
    ["admin", "tags", "infinite", filters] as const,
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteAdminUsers: (filters: object) =>
    ["admin", "users", "infinite", filters] as const,
  adminAccount: (id: string) => ["admin", "account", id] as const,
  adminStreamers: (filters: object) => ["admin", "streamers", filters] as const,
  adminReferenceData: () => ["admin", "reference-data"] as const,
  adminInternalAssignees: () => ["admin", "internal-assignees"] as const,
  adminChallenges: (status?: string) =>
    status
      ? (["admin", "challenges", "list", status] as const)
      : (["admin", "challenges", "list"] as const),
  adminChallenge: (id: string) => ["admin", "challenges", id] as const,
  adminChallengeSubmissions: (challengeId: string, status?: string) =>
    status
      ? (["admin", "challenges", challengeId, "submissions", status] as const)
      : (["admin", "challenges", challengeId, "submissions"] as const),
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteAdminChallengeSubmissions: (challengeId: string, status?: string) =>
    status
      ? ([
          "admin",
          "challenges",
          challengeId,
          "submissions",
          "infinite",
          status,
        ] as const)
      : ([
          "admin",
          "challenges",
          challengeId,
          "submissions",
          "infinite",
        ] as const),
  adminChallengeSubmissionCounts: (challengeId: string) =>
    ["admin", "challenges", challengeId, "submissions", "count"] as const,
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteAdminStreamers: (filters: object) =>
    ["admin", "streamers", "infinite", filters] as const,
  newsList: (filters: object) => ["news", "list", filters] as const,
  // Infinite queries require a distinct cache key from single-page queries.
  infiniteNewsList: (filters: object) =>
    ["news", "list", "infinite", filters] as const,
  newsDetail: (id: string) => ["news", "detail", id] as const,
  relatedNews: (id: string) => ["news", "related", id] as const,
  analyticsSummary: (filters: object) =>
    ["analytics", "summary", filters] as const,
  analyticsPageViews: (filters: object) =>
    ["analytics", "page-views", filters] as const,
  analyticsLogins: (filters: object) =>
    ["analytics", "logins", filters] as const,
  analyticsTopPages: (filters: object) =>
    ["analytics", "top-pages", filters] as const,
  challengesList: (filters: object = {}) =>
    ["challenges", "list", filters] as const,
  challengeDetail: (id: number | string) =>
    ["challenges", "detail", id] as const,
  challengeMySubmission: (challengeId: number | string) =>
    ["challenges", "submissions", "mine", challengeId] as const,
} as const
